<template>
    <div
        v-if="subscribes && subscribes.length"
        class="personal-subscribes"
    >
        <p class="personal-subscribes__title">Підписки</p>
        <div class="personal-subscribes__items">
            <span
                v-for="item in subscribes"
                class="personal-subscribes__item"
            >
                <span
                    @click="unsubscribe(item)"
                    class="personal-subscribes__remove"
                >
                    <svg
                        v-if="item.data.userIsSubscribed"
                        class="personal-subscribes__icon"
                    >
                        <use xlink:href="#svg-close"></use>
                    </svg>
                </span>
                <span
                    class="personal-subscribes__subscribe"
                    @click="subscribe(item)"
                >
                    {{ item.messages.button }}
                </span>
                {{ item.data.name }}
            </span>
        </div>
    </div>
</template>

<script>
import {
    mapState,
    mapMutations,
    mapActions,
} from 'vuex';
export default {
    name: 'PersonalSubscribes',
    // data() {
    //     return {
    //         response: {
    //
    //         }
    //     }
    // },
    computed: {
        ...mapState({
            subscribes: ({ personalCabinet }) => personalCabinet?.data?.subscribe,
            messages: ({ personalCabinet }) => personalCabinet?.data?.messages,
        }),
    },
    methods: {
        ...mapMutations({
            setStore: 'setStore',
        }),
        ...mapActions({
            updateData: 'personalCabinet/updateData',
        }),
        async subscribe(item) {
            this.setStore({ name: 'subscribe', value: item });

            this.$modal.show({
                    template: `
                            <ShoppingPresent
                                @close="$emit('close')"
                            />
                        `,
                },
                {},
                {
                    height: 'auto',
                    width: '1200px',
                    adaptive: true,
                },
                {
                    'before-close': this.updateData,
                },
            );
        },
        async unsubscribe(item) {
            try {
                const { path, ['params-example-data']: { action } } = item.routes.unSubscribe;
                const ID = item?.data?.userSubscribeId;

                const { status, data } = await axios.post(path, {
                    ID,
                    action,
                });
                if (status === 200) {
                    // this.response = data;
                    await this.updateData();
                }
            } catch (err) {
                console.error(err);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.personal-subscribes{
    margin-top: 32px;
    &__title{
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 24px;
        //border: 1px solid red;
    }
    &__items{
        display: grid;
        grid-template-columns: 1fr;
        grid-row-gap: 16px;
    }
    &__item{
        display: flex;
        align-items: center;
    }
    &__icon{
        display: block;
        width: 12px;
        height: 12px;
        fill: #C80024;
        margin-left: 12px;
        transform: translateY(-2px);
    }
    &__subscribe{
        display: flex;
        align-items: center;
        background-color: #618EAF;
        color: #fff;
        padding: 0 30px;
        height: 40px;
        margin-right: 24px;
        cursor: pointer;
        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        @include point-md{
            height: 48px;
        }
    }
    &__remove{
        cursor: pointer;
    }
}
</style>